function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 21L24.5 0V15C24.5 18.3137 21.8137 21 18.5 21H0Z",
  fill: "#F2512D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7536 17.9999C15.5926 17.9999 15.4386 17.9334 15.3283 17.8162L12.4916 14.7951C12.2705 14.5606 12.2828 14.1913 12.5173 13.9708C12.7523 13.7503 13.1216 13.762 13.3415 13.9965L15.7478 16.5579L20.6524 11.1901C20.8706 10.9515 21.2393 10.9358 21.4773 11.1528C21.7147 11.3698 21.731 11.739 21.514 11.9764L16.1841 17.8098C16.075 17.9299 15.9198 17.9988 15.7577 17.9999H15.7536Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7536 17.9999C15.5926 17.9999 15.4386 17.9334 15.3283 17.8162L12.4916 14.7951C12.2705 14.5606 12.2828 14.1913 12.5173 13.9708C12.7523 13.7503 13.1216 13.762 13.3415 13.9965L15.7478 16.5579L20.6524 11.1901C20.8706 10.9515 21.2393 10.9358 21.4773 11.1528C21.7147 11.3698 21.731 11.739 21.514 11.9764L16.1841 17.8098C16.075 17.9299 15.9198 17.9988 15.7577 17.9999H15.7536Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_41523_10478)"
});

function SvgScheduleSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41523_10478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 10,
    height: 7
  }, _ref4), _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleSelected);
export default __webpack_public_path__ + "static/media/schedule-selected.4f8b4db3.svg";
export { ForwardRef as ReactComponent };